import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link } from 'react-router-dom';

const ProjectViewPage = ({
  heroTitle,
  heroGradientText,
  clientLogo,
  client,
  // services,
  // deliverables,
  // techStack,
  heroImage,
  overviewImage,
  approachImage,
  overviewDescription,
  approachDescription,
  heroContainerStyle,
  commonSectionStyle,
  heroSectionStyle,
  heroGradientStyle,
  heroGlow1Style,
  heroGlow2Style,
  heroGlow3Style,
  containerWrapperStyle,
  heroImageContainerStyle,
  phoneContainerStyle,
  phoneGlowStyle,
  phoneShadowStyle,
  heroPhoneStyle,
  heroContentStyle,
  heroTitleStyle,
  gradientTextStyle,
  logoStyle,
  infoCardStyle,
  infoItemStyle,
  infoLabelStyle,
  badgesContainerStyle,
  // accentBadgeStyle,
  primaryBadgeStyle,
  // outlineBadgeStyle,
  overviewSectionStyle,
  approachSectionStyle,
  overviewImageContainerStyle,
  overviewImageStyle,
  overviewContentStyle,
  overviewGradientStyle,
  overviewGlowStyle,
  overviewGridStyle,
  overviewImageWrapperStyle,
  overviewImageGlowStyle,
  accentLineStyle,
  sectionTitleStyle,
  sectionHeaderStyle,
  sectionTextStyle,
  textContainerStyle,
  approachGradientStyle,
  approachGlow1Style,
  approachGlow2Style,
  approachGridStyle,
  approachAccentLineStyle,
  approachTextStyle,
  approachImageStyle,
  approachContentStyle,
  approachTitleStyle,
  approachImageWrapperStyle,
  approachImageGlowStyle,
  scrollAreaStyle,
  scrollContentStyle,
  infoLabel1,
  // infoLabel2,
  // infoLabel3,
  // infoLabel4,
  infoLabel5,
  website,
  visitWebsite,
  overviewTitle,
  approachTitle
}) => {
  return (
    <Box sx={heroContainerStyle}>
      <Box sx={{ ...commonSectionStyle, ...heroSectionStyle }}>
        <Box sx={heroGradientStyle} />
        <Box sx={heroGlow1Style} />
        <Box sx={heroGlow2Style} />
        <Box sx={heroGlow3Style} />
        <Container maxWidth="xl" sx={containerWrapperStyle}>
          <Box sx={heroImageContainerStyle}>
            <Box sx={phoneContainerStyle}>
              <Box sx={phoneGlowStyle} />
              <Box sx={phoneShadowStyle} />
              <Box
                component="img"
                src={heroImage}
                alt={`${client} App Interface`}
                sx={heroPhoneStyle}
              />
            </Box>
          </Box>
          <Box sx={heroContentStyle}>
            <Typography variant="h1" sx={heroTitleStyle}>
              {heroTitle}{' '}
              <Box component="span" sx={gradientTextStyle}>
                {heroGradientText}
              </Box>
            </Typography>
            <Box sx={infoCardStyle}>
              <Box sx={infoItemStyle}>
                <Typography variant="body2" sx={infoLabelStyle}>
                  {infoLabel1}
                </Typography>
                <Box sx={badgesContainerStyle}>
                  {clientLogo && (
                    <Box
                      component="img"
                      src={clientLogo}
                      alt={`${client} logo`}
                      sx={{
                        height: 50,
                        width: 'auto',
                        verticalAlign: 'middle',
                        ...logoStyle
                      }}
                    />
                  )}
                </Box>
              </Box>
              {/* <Box sx={infoItemStyle}>
                <Typography variant="body2" sx={infoLabelStyle}>
                  {infoLabel2}
                </Typography>
                <Box sx={badgesContainerStyle}>
                  {services?.map((item, i) => (
                    <Box key={i} component="span" sx={outlineBadgeStyle}>
                      {item}
                    </Box>
                  ))}
                </Box>
              </Box>
              <Box sx={infoItemStyle}>
                <Typography variant="body2" sx={infoLabelStyle}>
                  {infoLabel3}
                </Typography>
                <Box sx={badgesContainerStyle}>
                  {deliverables?.map((item, i) => (
                    <Box key={i} component="span" sx={accentBadgeStyle}>
                      {item}
                    </Box>
                  ))}
                </Box>
              </Box>
              <Box sx={infoItemStyle}>
                <Typography variant="body2" sx={infoLabelStyle}>
                  {infoLabel4}
                </Typography>
                <Box sx={badgesContainerStyle}>
                  {techStack?.map((item, i) => (
                    <Box key={i} component="span" sx={outlineBadgeStyle}>
                      {item}
                    </Box>
                  ))}
                </Box>
              </Box> */}
              {website && (
                <Box sx={infoItemStyle}>
                  <Typography variant="body2" sx={infoLabelStyle}>
                    {infoLabel5}
                  </Typography>
                  <Box sx={badgesContainerStyle}>
                    <Link
                      to={website}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="none"
                      style={{
                        ...primaryBadgeStyle,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          opacity: 0.9,
                          transform: 'scale(1.05)'
                        }
                      }}
                    >
                      {visitWebsite}
                      <OpenInNewIcon sx={{ fontSize: 18 }} />
                    </Link>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Container>
      </Box>
      <Box sx={{ ...commonSectionStyle, ...overviewSectionStyle }}>
        <Box sx={overviewGradientStyle} />
        <Box sx={overviewGlowStyle} />
        <Container maxWidth="xl">
          <Grid
            container
            spacing={6}
            alignItems="center"
            justifyContent="center"
            sx={overviewGridStyle}
          >
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Box sx={overviewContentStyle}>
                <Box sx={sectionHeaderStyle}>
                  <Box sx={accentLineStyle} />
                  <Typography variant="h2" sx={sectionTitleStyle}>
                    {overviewTitle}
                  </Typography>
                </Box>
                <Box sx={textContainerStyle}>
                  {overviewDescription?.map((text, i) => (
                    <Typography key={i} variant="body1" sx={sectionTextStyle}>
                      {text}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Box sx={overviewImageContainerStyle}>
                <Box sx={overviewImageWrapperStyle}>
                  <Box sx={overviewImageGlowStyle} />
                  <Box
                    component="img"
                    src={overviewImage}
                    alt="Overview"
                    sx={overviewImageStyle}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ ...commonSectionStyle, ...approachSectionStyle }}>
        <Box sx={approachGradientStyle} />
        <Box sx={approachGlow1Style} />
        <Box sx={approachGlow2Style} />
        <Container maxWidth="xl">
          <Grid
            container
            spacing={6}
            alignItems="center"
            justifyContent="center"
            sx={approachGridStyle}
          >
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Box sx={approachContentStyle}>
                <Box sx={sectionHeaderStyle}>
                  <Box sx={approachAccentLineStyle} />
                  <Typography variant="h2" sx={approachTitleStyle}>
                    {approachTitle}
                  </Typography>
                </Box>
                <Box sx={textContainerStyle}>
                  {approachDescription?.map((text, i) => (
                    <Typography key={i} variant="body1" sx={approachTextStyle}>
                      {text}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Paper sx={scrollAreaStyle}>
                <Box sx={scrollContentStyle}>
                  <Box sx={approachImageWrapperStyle}>
                    <Box sx={approachImageGlowStyle} />
                    <Box
                      component="img"
                      src={approachImage}
                      alt="App Design Approach"
                      sx={approachImageStyle}
                    />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default ProjectViewPage;
